import './index.scss';

$(document).ready(() => {
  const modal = document.getElementById('js-subscription-choice-modal');
  if (!modal) return;

  const sheet = modal.querySelector('.qc-modal__sheet') || modal;
  let previouslyFocused = null;

  const getFocusable = container =>
    Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(
      el =>
        !el.hasAttribute('disabled') &&
        el.getAttribute('aria-hidden') !== 'true'
    );

  const open = () => {
    if (modal.classList.contains('is-open')) return;

    previouslyFocused = document.activeElement;

    modal.style.display = 'block';
    modal.classList.remove('is-hidden');
    modal.offsetHeight;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-open');

    const focusables = getFocusable(sheet);
    (focusables[0] || sheet).focus();
    
    UserTracker.emit('event', {
      eventName: 'paywall viewed',
      data: {
        'request path': window.location.pathname,
        'paywall type': 'escolher plano',
      }
    });
  };

  const close = (immediate = false) => {
    if (!modal.classList.contains('is-open')) return;

    if (document.activeElement && modal.contains(document.activeElement)) {
      document.activeElement.blur();
    }

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-open');

    if (immediate) {
      modal.style.display = 'none';
    } else {
      setTimeout(() => {
        if (!modal.classList.contains('is-open')) {
          modal.style.display = 'none';
        }
      }, 500);
    }

    if (previouslyFocused && document.body.contains(previouslyFocused)) {
      previouslyFocused.focus();
    }
  };

  const trackPaywallButtonClick = (planType) => {
    const payload = {
      'request path': window.location.pathname,
      'plan type': planType,
      'source project': 'odin',
    };

    return new Promise((resolve) => {
      UserTracker.emit('event', { 
        eventName: 'paywall button clicked', 
        data: payload 
      });
      
      setTimeout(resolve, 500);
    });
  };

  const freeBtn = modal.querySelector('.free-cta');
  const unlimitedBtn = modal.querySelector('.unlimited-cta');

  if (freeBtn) {
    freeBtn.addEventListener('click', () => {
      void trackPaywallButtonClick('gratuito');
      close();
    });
  }

  if (unlimitedBtn) {
    unlimitedBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      unlimitedBtn.disabled = true;
      await trackPaywallButtonClick('pago');
      
      close(true);
      window.location.assign(unlimitedBtn.href);
    }, { once: true });
  }

  window.openSubscriptionChoiceModal = open;
  window.closeSubscriptionChoiceModal = close;
});
